export default {"src":"/_next/static/media/basket_ball.4fa6253b.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};